//no-unused-vars
import React, {Component, CSSProperties} from 'react';
import Carousel from 'react-bootstrap/Carousel';
//import Carousel from 'react-responsive-carousel';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import Img1 from './img/1.jpg';
import Img2 from './img/2.jpg';
import Img3 from './img/3.jpg';
import Img4 from './img/4.jpg';
import Img5 from './img/5.jpg';
import Img6 from './img/6.jpg';

import Img7 from './img/7.jpg';
import Img8 from './img/8.jpg';
import Img9 from './img/9.jpg';
import Img10 from './img/10.jpg';

import Img11 from './img/11.jpg';
import Img12 from './img/12.jpg';
import Img13 from './img/13.jpg';
import Img14 from './img/14.jpg';
import Img15 from './img/15.jpg';
import Img16 from './img/16.jpg';
import Img17 from './img/17.jpg';
import Img18 from './img/18.jpg';
import Img19 from './img/19.jpg';

//https://www.kul.pl/files/1458/logo_kul_en.jpg
import LogoKUL1 from './kul_logo.png';
import LogoKUL2 from './wnsinz_logo.jpg';
import LogoLTN from './ltn_transparent2.png';
import LogoPWSZ from './PWSZ_logo.png';
import LogoPANS from './PANS_logo-z-napisem2.png';
//'https://p.lodz.pl/themes/custom/politechnika/logo.svg';
import LogoPL from './PLLogo.jpg';
import LogoPLWEEIA from './weeia-en.svg';
import LogoWEEIA from './logoweeia.png';
import LogoSENAT from './logo-senatu.jpg';
//"https://www.fds.uni.lodz.pl/wp-content/uploads/2018/09/wfis-x75.png"
import LogoWFIS from './wfis-x75.png';
import ReactGA from 'react-ga';
//import LogoPK from './LogoPK.png';
//import LogoPKold from './PK_WIiT_SYMETRYCZNE_RGB-EN.png';
//import LogoPK from './PK_WIEiK.jpg';
import LogoPLIF from './logoPLIF.svg';
import LogoQHS from './QHS_Logo2.png';
import LogoUL from './logo_ul_h_en_rgb.png';
import LogoHCSYouTube from './HCSYouTubeLogo.jpg';
import AddAbstractDeadlineToUserCallendar from './MyCallendar';
import LogoDMCS from './DMCS_logo.svg';

import ImgStat from './Stat2021.png';

import ApplicationFormODT from "./Application_form2.odt";
import TemplateFormPDF from "./HyperComplexSem_template.pdf";
import TemplateFormTEX from "./HyperComplexSem_template.tex";
//debugger;

import HCSProgramAndAbstracts from "./HCS2023_program-abstracts_2023-07-27.pdf";
import HCSSzyld from "./HyperComplex Seminar in Fundamental Modelling.jpg";

export const MainPage = () => (
  <div className='container-fluid' > 
	<div class="row">
		<div class="col-md-6">
			&nbsp;
		</div>
	</div>
	
    <div class="row">

        <div class="col-md-11">
			<div class="d-flex justify-content-center">
				<a href="https://www.youtube.com/channel/UC8Ka22Tol-wxUAeh8832QGQ/videos"  target="_blank" title={'The (Hyper)Complex Seminar on YouTube'}><img src={HCSSzyld} alt={'HCS on YouTube'} height="128"/></a>
            		</div>
        </div>
    </div>
	
	<div class="row">
            <div class="d-flex justify-content-center">
                        
            </div>
    </div>
	
	<div class="row">
		<div class="d-flex justify-content-center">	
						&nbsp;
		</div>
	</div>
	
	<div class="row">
		<div class="col-md-1">
		</div>
		<div class="col-md-6">
			<div className='container-fluid' >
				<div class="row">
					<div class="d-flex justify-content-left">	
						<h5>Organisers</h5>
					</div>
				</div>
				
				<div class="row" style={{'border-right' : '1px solid #aaa'}} >
					<div class="d-flex justify-content-center">	
						<div class="KULlogo">
							<a href="https://www.kul.pl/news,29385.html" title={'Faculty of Natural Science and Health\nThe John Paul II Catholic University of Lublin'} target="_blank"><img src={LogoKUL1}
							alt={'Faculty of Natural Science and Health\nThe John Paul II Catholic University of Lublin'} height="64"/></a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="PANSlogo">
							<a href="https://panschelm.edu.pl" title={'Institute of Mathematics\nThe University College of Applied Sciences in Chelm'} target="_blank"><img src={LogoPANS}
							alt={'Institute of Mathematics\nThe University College of Applied Sciences in Chelm'} height="64"/></a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="PLlogo">
							<a href="http://www.weeia.p.lodz.pl/en/" title={'Faculty of Electrical, Electronic, Computer and Control Engineering\nLodz University of Technology'} target="_blank"><img src={LogoPLWEEIA}
							alt={'Faculty of Electrical, Electronic, Computer and Control Engineering\nLodz University of Technology'} height="64"/></a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="DMCSlogo">
							<a href="http://www.dmcs.p.lodz.pl/en/" title={'Department of Microelectronics and Computer Science\nFaculty of Electrical, Electronic, Computer and Control Engineering\nLodz University of Technology'} target="_blank"><img src={LogoDMCS}
							alt={'Department of Microelectronics and Computer Science\nFaculty of Electrical, Electronic, Computer and Control Engineering\nLodz University of Technology'} height="64"/></a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="PLIFlogo">
							<a href="https://fizyka.p.lodz.pl/en/" title={'Institute of Physics\nFaculty of Technical Physics, Information Technology and Applied Mathematics\nLodz University of Technology'} target="_blank"><img src={LogoPLIF}
							alt={'Institute of Physics\nFaculty of Technical Physics, Information Technology and Applied Mathematics\nLodz University of Technology'} height="64"/></a>
						</div>						
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="Empty">
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="Empty">
						</div>
					</div>
				</div>
			</div>
		</div>	
		<div class="col-md-2">	
				<div class="row">
					<div class="d-flex justify-content-left">	
						<h5>Honorary organisers</h5>
					</div>
				</div>
				
				<div class="row" style={{'border-right' : '1px solid #aaa'}}>
					<div class="d-flex justify-content-left">	
						<div class="UNIVLodzlogo">
							<a href="https://www.wfis.uni.lodz.pl/kfcs/" title={'Department of Solid State Physics\nFaculty of Physics and Applied Informatics\nUniversity of Lodz'}>
							<img src={LogoUL}
							alt={'Department of Solid State Physics\nFaculty of Physics and Applied Informatics\nUniversity of Lodz'} height="64"/>
							</a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="ŁTNlogo">
							<a href="https://www.ltn.lodz.pl/" title="Łódź Scientific Society"><img src={LogoLTN}
							alt="Łódź Scientific Society" height="64"/></a>
						</div>						
					</div>
				</div>
						
		</div>
		<div class="col-md-3">	
				<div class="row">
					<div class="d-flex justify-content-left">	
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<h5>Honorary Partners</h5>
					</div>
				</div>
				
				<div class="row">
					<div class="d-flex justify-content-left">	
						
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<div class="QHSlogo">
							<a href="http://www.quantumhardwaresystems.com" title={'Quantum Hardware Systems'}><img src={LogoQHS}
							alt={'Quantum Hardware Systems'} height="64"/></a>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</div>
				</div>
						
		</div>
		<div class="col-md-1">
		</div>
	</div>
	
	<div class="row">
		<div class="d-flex justify-content-center">	
						&nbsp;
		</div>
	</div>

<div class="row justify-content-center">
<div class="d-flex justify-content-center">	
		<h5><b>XXII<sup>{"nd"}</sup> HyperComplex Seminar will be held in Lodz, Poland</b></h5>
	</div>
</div>
<div class="row justify-content-center">
<div class="d-flex justify-content-center">	
                <h6><b>at Lodz Univeristy of Technology (Aula Magica - Institute of Physics)</b></h6>
	</div>
</div>

<div class="row justify-content-center">
<div class="d-flex justify-content-center">
		<h5><b>14<sup>{"th"}</sup> – 18<sup>{"th"}</sup> September 2024</b></h5>
	</div>
</div>
<div class="row justify-content-center">
<div class="d-flex justify-content-center">
	</div>
</div>
<div class="row justify-content-center">
<div class="d-flex justify-content-center">
                <b>Please see </b> &nbsp;
		<a href="https://czasopisma.ltn.lodz.pl/index.php/Bulletin/issue/view/382"  target="_blank" title={'post-conference Hypercomplex Monography (of XXII<sup>{"nd"}</sup> edition)'}>
			<b>Post-conference Hypercomplex Monography of XXth edition</b></a>

	</div>
</div>
	
	<div class="row">
		
		
		<div class="col-md-6">		
			<div className='container-fluid' > 
				<div class="row">
			
					
	<p>We are planning the following sessions:</p>
<p>
<table class="table">


<tbody>
 <tr>
 <th class="align-top"><b>(A) Mathematics (especially (hyper)complex analysis)</b></th>
 <th>(Hyper)complex analysis<br/>
     Non-linear ODEs and PDEs and differential equations<br/>
     Complex structures<br/>
 </th>
 </tr>
 
 <tr>
 <th class="align-top"><b>(B) Physics and Statistics</b></th>
 <th>Physics, Statistics and HyperComplex analysis<br/> 
     Computer Modelling<br/>
     Classical Physics</th>
 </tr>
 
 <tr>
 <th class="align-top"><b>(C) Informatics and Machine Learning</b></th>
 <th>Machine Learning<br/>
     Modern informatics<br/>
     Students' Session</th>
 </tr>

 <tr>
 <th class="align-top"><b>(D) Classical Electronics</b></th>
 <th>Cryogenic CMOS<br/>
     ARUZ (Real Complex Systems Analyzer) <a href="https://k22.p.lodz.pl/badania/realizowane-prace-badawcze/aruz" title={'Analizator Rzeczywistych Układów Złożonych'} target="_blank"><sup>[1]</sup></a> 
     <a href="https://naukawpolsce.pl/aktualnosci/news%2C407449%2Clodzunikalny-symulator-procesow-chemicznych-aruz-pozytywnie-przeszedl-testy.html" title={'Analizator Rzeczywistych Układów Złożonych'} target="_blank"><sup>[2]</sup></a>
     </th>
 </tr>
 
 <tr>
 <th class="align-top"><b>(E) Quantum Electronics, Chemistry and Computer Science</b></th>
 <th>Q-Technology<br/>
     Q-Mechanics
     Applications</th>
 </tr>

 <tr>
 <th class="align-top"><b>(F) Industrial Applications</b></th>
 <th>Quaternions</th>
 </tr>

 <tr>
 <th class="align-top"><b>(G) Didactics and History of Mathematics</b></th>
 </tr>
 
</tbody>

</table>
</p>

<p>Video playlists of previous edition of HyperComplex Seminar are here
<ul>
<li>A <a href="https://www.youtube.com/playlist?list=PLPmadLSjuvj6VJSCJzRIBPCPdOVnhzQ8b">Mathematics</a> 
</li>
<li>B <a href="https://www.youtube.com/playlist?list=PLPmadLSjuvj5G5-GDmAUW7ApmZHiBLS5j">Physics and Statistics</a> 
</li>
<li>C <a href="https://www.youtube.com/playlist?list=PLPmadLSjuvj4HefR-Kp88fAyFOFbqor7U">Informatics</a> 
</li>
<li>D <a href="https://www.youtube.com/playlist?list=PLPmadLSjuvj4liaZSo9Jjch51ZbJ_wC0A">Classical Quantum Electronics</a> 
</li>
</ul></p>
<p>We are planning a post-conference monograph to appear both in paper and in electronic forms.
The previous conference monograph can be found here
(HYPER)COMPLEX SEMINAR 2024 IN MEMORIAM OF PROF. JULIAN ŁAWRYNOWICZ. <a href="https://journals.ltn.lodz.pl/index.php/Bulletin/issue/view/382" target="_blank" title={'(HYPER)COMPLEX SEMINAR 2021 IN MEMORIAM OF PROF. JULIAN ŁAWRYNOWICZ. A monograph'}>A monograph</a> | Bulletin de la Société des Sciences et des Lettres de Łódź (lodz.pl)</p>
<p>If you wish to give a talk or hang a poster write your abstract in latex and pdf using the templates, and fill the application form.</p>
<p>You can download them here: <a href={ApplicationFormODT} target="_blank">Application form (ODT file)</a>, <a href={TemplateFormTEX} target="_blank">Template TEX file</a>, <a href={TemplateFormPDF} target="_blank">Template PDF file</a>.</p>

<p>Free listeners please only fill the application form.</p>
<p>Send the three files to Hyper Complex Seminar <b>e-mail</b>: <a href="mailto:HyperComplexSeminar@gmail.com">HyperComplexSeminar@gmail.com</a>. </p>


<p>Please consider inviting your co-workers, and, in patricular, students who might be interested in the topics of the Seminar.'
<p>We hope to meet you at the Hypercomplex Seminar 2024.</p>
    </p>
	<p>
	</p><p>	
	<ul class="list-inline">
		<li>Organizing Commettee at <b>e-mail</b>: <a href="mailto:HyperComplexSeminar@gmail.com">HyperComplexSeminar@gmail.com</a> or </li>
		<li>Łódzkie Towarzystwo Naukowe ("HyperComplex Seminar"), ul. M.Skłodowskiej-Curie 11, 90-505 Łódź, Poland.</li>
	</ul>
	</p>
				</div>
			</div>
		</div>
		
		
		<div class="col-md-6">
			<Carousel fade="true" slide="false" interval="8000" controls="false" indicators="true" keyboard="false">
			
				<Carousel.Item  >
					<img className="d-block w-100" src={Img1} alt="(Hyper)Complex Seminar 2016"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2001-2021</h3>
						<p>Będlewo Palace - The Research and Conference Centre of IM PAN.</p>
					</Carousel.Caption>
				</Carousel.Item> 
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img5} alt="(Hyper)Complex Seminar 2009"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2019</h3>	
						<p>Away session in China</p>						
					</Carousel.Caption>
				</Carousel.Item> 	
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img6} alt="(Hyper)Complex Seminar 2012"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2012</h3>						
					</Carousel.Caption>
				</Carousel.Item> 	
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img4} alt="(Hyper)Complex Seminar 2016"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2016</h3>
						<p>&nbsp;</p>
					</Carousel.Caption>
				</Carousel.Item>
							
				<Carousel.Item  >
					<img className="d-block w-100" src={Img3} alt="(Hyper)Complex Seminar 2017"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2017</h3>
						<p>&nbsp;</p>
					</Carousel.Caption>
				</Carousel.Item> 
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img2} alt="(Hyper)Complex Seminar 2018"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2018</h3>
						<p>A conversations at the blackboard - the piece of elementary proof.</p>
					</Carousel.Caption>
				</Carousel.Item> 				
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img7} alt="(Hyper)Complex Seminar 20xx"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 20xx</h3>						
					</Carousel.Caption>
				</Carousel.Item>

				<Carousel.Item  >
					<img className="d-block w-100" src={Img8} alt="(Hyper)Complex Seminar 20xx"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 20xx</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img14} alt="(Hyper)Complex Seminar 2008"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2008</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img9} alt="(Hyper)Complex Seminar 20xx"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 20xx</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img15} alt="(Hyper)Complex Seminar 2007"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2007</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img10} alt="(Hyper)Complex Seminar 20xx"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 20xx</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  > 
					<img className="d-block w-100" src={Img11} alt="(Hyper)Complex Seminar 2012"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2012</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img12} alt="(Hyper)Complex Seminar 2007"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2007</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img13} alt="(Hyper)Complex Seminar 2006"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2006</h3>						
					</Carousel.Caption>
				</Carousel.Item>
							
				<Carousel.Item  >
					<img className="d-block w-100" src={Img16} alt="(Hyper)Complex Seminar 2007"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2007</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img17} alt="(Hyper)Complex Seminar 2007"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2007</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img18} alt="(Hyper)Complex Seminar 2006"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2006</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
				<Carousel.Item  >
					<img className="d-block w-100" src={Img19} alt="(Hyper)Complex Seminar 2007"/>
					<Carousel.Caption>
						<h3>(Hyper)Complex Seminar 2007</h3>						
					</Carousel.Caption>
				</Carousel.Item>
				
			</Carousel>
			
			<div class="row">
					<div class="d-flex justify-content-center">	
						&nbsp;
					</div>
			</div>
			
			<div class="row">					
				</div>

<p>&nbsp;</p>
<p>				
<div class="row">
<div class="col-md-1">	
&nbsp;&nbsp;&nbsp;				
</div>
<div class="col-md-1">					
<table class="table table-bordered-primary">
<thead>
 <tr class="table-info">
 <th class="align-top"><b>Program and abstract </b></th> 
 </tr>
</thead> 

<tbody>
 <tr class="table-info">
 <th><b> The last version of <a href={HCSProgramAndAbstracts} target="_blank">PDF</a>file (2023-07-14, 23:35 PM). </b></th>
 </tr>
  
 
</tbody>
</table>
</div>

</div>		
</p>				
<p>&nbsp;</p>


		</div>
		
	</div>
	
	<div class="row">
		<div class="d-flex justify-content-center">
		<b><h5>(Hyper)Complex Seminar 2021 - Participants</h5></b>
		</div>
	</div>
	<div class="row">
		<div class="col-md-1">
			&nbsp;
		</div>
		<div class="col-md-10">			
			<div class="d-flex justify-content-center">											
				<img src={ImgStat} alt={'(Hyper)Complex Seminar 2021 - Participants'} height="640"/>
			</div>
		</div>
		<div class="col-md-1">
			&nbsp;
		</div>
	</div>
	
  </div>
);

//export default MainPage


